<template>
  <div class="loading-box" v-show="show">
    <div class="img-box">
      <img src="../../assets/img/loading.gif" alt=""/>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      duration:null
    };
  },
  beforeRouteUpdate: (to, from, next) => {
    next(vm => {
      this.change()
    })
  },
  created () {
    // window.onhashchange = this.change
  },
  methods: {
    change () {
      this.show = false
    }
  },
  watch: {
    show (newval, oldval) {
      if (newval && this.duration) {
        setTimeout(() => {
          this.show = false
        }, this.duration);
      }
    },
  },
};
</script>

<style  rel='stylesheet/stylus' lang='stylus' scoped>
.loading-box
  position absolute
  top 0
  bottom 0
  width 100%
  z-index 999
  display flex
  align-items center
  justify-content center
  background rgba(0,0,0,0.3)
  .img-box
    width 150px
    height 150px
    border-radius 15px
    overflow hidden
    img
      width 100%
      height 100%
</style>



// WEBPACK FOOTER //
// src/starcharge/plugin/loading/loading.vue